import TagManager, { TagManagerArgs } from 'react-gtm-module';

export const initializeTagManager = () => {
  const args: TagManagerArgs = {
    gtmId: process.env.REACT_APP_TAG_MANAGER_ID,
  };

  TagManager.initialize(args);
};
